import React, { useEffect } from 'react';
import {
  Dashboard as DashboardIcon,
  BarChart as BarChartIcon,
  Description as DescriptionIcon,
  AccountBox as AccountBoxIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { AppProvider, DashboardLayout } from '@toolpad/core';

import { Dashboard } from './Dashboard';
import { Footer } from './Footer/Footer';
import { usePath } from '../CustomHooks/usePath';

import CashClever from './Cashclever.png';

import './LayoutWrapper.css';

const NAVIGATION = [
  {
    kind: 'header',
    title: 'Main',
  },
  {
    segment: 'dashboard',
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  {
    segment: 'profile',
    title: 'Profile',
    icon: <AccountBoxIcon />,
  },
  {
    kind: 'divider',
  },
  {
    kind: 'header',
    title: 'Rates Information',
  },
  {
    segment: 'rates',
    title: 'Rates Summary',
    icon: <BarChartIcon />,
    // segment: 'rates',
    // title: 'Rates Summary',
    // icon: <BarChartIcon />,
    // children: [
    //   {
    //     segment: 'comparison',
    //     title: 'Comparison Summary',
    //     icon: <DescriptionIcon />,
    //   },
    //   {
    //     segment: 'analytics',
    //     title: 'Rates Analytics',
    //     icon: <DescriptionIcon />,
    //   },
    // ],
  },
  {
    segment: 'analytics',
    title: 'Rates Analytics',
    icon: <DescriptionIcon />,
  },
  {
    kind: 'divider',
  },
  {
    kind: 'header',
    title: 'Logout',
  },
  {
    segment: 'logout',
    title: 'Logout',
    icon: <LogoutIcon />,
  },
  // {
  //   segment: 'rates',
  //   title: 'Rates Summary',
  //   icon: <BarChartIcon />,
  //   children: [
  //     {
  //       segment: 'comparison',
  //       title: 'Comparison Summary',
  //       icon: <DescriptionIcon />,
  //     },
  //     {
  //       segment: 'analytics',
  //       title: 'Rates Analytics',
  //       icon: <DescriptionIcon />,
  //     },
  //   ],
  // },
  //   {
  //     segment: 'integrations',
  //     title: 'Integrations',
  //     icon: <LayersIcon />,
  //   },
];

export const LayoutWrapper = ({ children, path = '/', isOnDashboard }) => {
  const [_, setPathname, router] = usePath(path);

  useEffect(() => {
    // This is because we are using toolpad and we need to override the css content
    // we need to work on updating this asap after launch.
    const h6HeaderTag = document.getElementsByTagName('h6')?.[0];
    h6HeaderTag.innerHTML = `<h5 class="cash-clever-header"> <img src=${CashClever} height="30" width="30" id="cashcleverImg" alt="CashCleverLogo" /> CashClever </h5>`;
    h6HeaderTag.style.color = 'white';
    h6HeaderTag.style.backgroundColor = 'black';
    h6HeaderTag.style.fontSize = '24px';

    const buttonElement = document.querySelectorAll('[aria-label="Switch to light mode"]')?.[0];

    if (buttonElement) {
      buttonElement.click();
    }
  }, []);

  return (
    <AppProvider navigation={NAVIGATION} router={router}>
      <DashboardLayout>
        {isOnDashboard && <Dashboard setPathname={setPathname} />}
        {children}
      </DashboardLayout>
      <div className="desktop-view-only">
        <Footer currentPath={path} />
      </div>
    </AppProvider>
  );
};
